<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      title="Edit KPN Provisioning Details"
      :large="false"
      :addClose="true"
      @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>

      <fade-transition group>
        <dean-form-row id="klantnummer" label="donor klantnummer" type="string" v-model="data.donorCustomerNumber"
                       key="donorCustomerNumber" :disabled="!this.payloadData.canChangeDonorCustomerNumber"
                       :requiredField="this.payloadData.canChangeDonorCustomerNumber"
                       :warning="$v.data.donorCustomerNumber.$error"></dean-form-row>
      </fade-transition>

      <date-input
          :label="portingWishDateLabel"
          :value="data.portingWishDate"
          :min-date="minimumDate"
          :requiredField="this.payloadData.canChangePortingWishDate"
          :disabled="!this.payloadData.canChangePortingWishDate"
          :warning="$v.data.portingWishDate.$error"
          @dateValueChanged="dateValueChanged"></date-input>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import axios from 'axios';
import {
  // SVG
  warningIcon,
  // COMPONENTS
  deanDialog,
  deanDialogButtonGroup, saveIcon,
} from '@deanone/dean-components';
import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import {deanDialogBus} from '@/main';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotificationFromData, validationMessage} from '@/mixins/validations';
import {FadeTransition} from 'vue2-transitions';
import {getErrorFromResponse} from "@/mixins/errorMessage";
import Multiselect from 'vue-multiselect';
import DateInput from '@/components/DateInput.vue';

@Component({
    components: {
      DateInput,
      Multiselect,
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
      FadeTransition,
    },
    mixins: [validationMixin],
  })

  export default class EditKpnProvisioningDetailsDialog extends Vue {
  @Prop() public payloadData!: any;

  public timer: any = undefined;

  @Validations()
  get validations() {
    const valData: any = {
      data: {
        donorCustomerNumber: {
          required: this.payloadData.canChangeDonorCustomerNumber
        },
        portingWishDate: {
          required: this.payloadData.canChangePortingWishDate
        },
      },
    };

    return valData;
  }

  public data: {[key: string]: any} = {
    donorCustomerNumber: this.payloadData.donorCustomerNumber,
    portingWishDate: this.payloadData.portingWishDate,
  };

  public close() {
    deanDialogBus.$emit('close');
  }

  get minimumDate() {
    const today = new Date();
    const tomorrow = new Date(today.setDate(today.getDate() + 1));

    if (this.payloadData.firstPossiblePortingDate) {
      const firstPossibleDate = new Date(this.payloadData.firstPossiblePortingDate);

      return firstPossibleDate <= today ? tomorrow : firstPossibleDate;
    }

    return tomorrow;
  }

  get portingWishDateLabel() {
    return 'porteerwensdatum';
  }

  public dateValueChanged(portingWishDate: string) {
    this.data.portingWishDate = portingWishDate;
  }


  public save() {
    // @ts-ignore-next-line
    this.$v.data.$touch();

    let requestPayload = {
      orderLineId: this.payloadData.orderLineId,
      donorCustomerNumber: null,
      portingWishDate: null,
    };

    if (this.data.donorCustomerNumber) {
      requestPayload.donorCustomerNumber = this.data.donorCustomerNumber;
    }

    if (this.data.portingWishDate) {
      requestPayload.portingWishDate = this.data.portingWishDate;
    }

    if (!this.$v.$invalid) {
      this.$emit('setLoad', true);
      axios.post('/-/trade/api/mobile.order.line.stnProvisioning.edit', requestPayload).then(
        (response: any) => {
          this.$toast({
            icon: saveIcon,
            text: String(this.$t('messages.changeKpnMobileProvisioning')),
            theme: 'success',
          });
          this.close();
        },
        (error: any) => {
          const errorResponse = error.response.data;
          const errorMessage: string | null = getErrorFromResponse(errorResponse, this.$store.state.main.notification.messages.couldNotSendData.text);

          this.$toast(validationMessage(errorMessage));
        },
      ).finally(() => {
        deanDialogBus.$emit('saved');

        this.$emit('setLoad', false);
      });
    } else {
      this.$toast(createNotificationFromData(this.$v.data));
    }
  }

  public created() {
    this.$emit('setLoad', false);
  }
}
</script>

<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

:deep(.dialog .dean-dialog-container) {
  width: 600px;
}

:deep(.dean-dialog-content .dean-dialog-slot) {
  overflow-y: visible;
}

.input-label {
  padding-left: 21px;
}
</style>

